import { getTermValue, setTerm } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { infrastructureItemToJsonQueryFieldMap } from '../../../../JsonQuery/constants/infrastructureFieldMap';
import { EInfrastructureItem } from '../../../../api-models/common/json_query';

const ID = 'infrastructure' as const;

const INFRASTRUCTURE_LABELS: Record<EInfrastructureItem, string> = {
  [EInfrastructureItem.CarWash]: 'Автомойка',
  [EInfrastructureItem.CarService]: 'Автосервис',
  [EInfrastructureItem.Pharmacy]: 'Аптека',
  [EInfrastructureItem.ClothesStudio]: 'Ателье',
  [EInfrastructureItem.ATM]: 'Банкомат',
  [EInfrastructureItem.Pool]: 'Бассейн',
  [EInfrastructureItem.Buffet]: 'Буфет',
  [EInfrastructureItem.WarehouseComplex]: 'Выставочно-складской комплекс',
  [EInfrastructureItem.Hotel]: 'Гостиница',
  [EInfrastructureItem.Cafe]: 'Кафе',
  [EInfrastructureItem.Cinema]: 'Кинотеатр',
  [EInfrastructureItem.ConferenceRoom]: 'Конференц-зал',
  [EInfrastructureItem.MedicalCenter]: 'Медицинский центр',
  [EInfrastructureItem.Minimarket]: 'Минимаркет',
  [EInfrastructureItem.NotaryOffice]: 'Нотариальная контора',
  [EInfrastructureItem.Department]: 'Отделение банка',
  [EInfrastructureItem.Park]: 'Парк',
  [EInfrastructureItem.Restaurant]: 'Ресторан',
  [EInfrastructureItem.BeautyShop]: 'Салон красоты',
  [EInfrastructureItem.Warehouse]: 'Складские помещения',
  [EInfrastructureItem.Canteen]: 'Столовая',
  [EInfrastructureItem.Supermarket]: 'Супермаркет',
  [EInfrastructureItem.ShoppingArea]: 'Торговая зона',
  [EInfrastructureItem.FitnessCentre]: 'Фитнес-центр',
  [EInfrastructureItem.Studio]: 'Фотостудия',
  [EInfrastructureItem.CentralReception]: 'Центральный ресепшен',
};

const ALL_ITEMS = Object.keys(infrastructureItemToJsonQueryFieldMap).map(Number) as EInfrastructureItem[];

export const infrastructureTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const tags = ALL_ITEMS.filter(item =>
      Boolean(getTermValue(infrastructureItemToJsonQueryFieldMap[item])(jsonQuery)),
    ).map(item => ({ label: INFRASTRUCTURE_LABELS[item], value: createTagValue(ID, item.toString()) }));

    return tags.length > 0 ? tags : null;
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const item = Number(removingTagValue) as EInfrastructureItem;
    const field = infrastructureItemToJsonQueryFieldMap[item];

    if (!field) {
      return jsonQuery;
    }

    return setTerm(field)(jsonQuery)(null);
  },
};
